import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("@/view/indexPage.vue"),
    meta: {
      title: "首页",
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/view/aboutPage.vue"),
    meta: {
      title: "关于我们",
    }
  },
  {
    path: "/compare",
    name: "Compare",
    component: () => import("@/view/comparePage.vue"),
    meta: {
      title: "合作伙伴",
    }
  },
  {
    path: "/introduce",
    name: "Introduce",
    component: () => import("@/view/introducePage.vue"),
    meta: {
      title: "方案介绍",
    }
  },
  {
    path: "/NTN",
    name: "Ntn",
    component: () => import("@/view/ntnPage.vue"),
    meta: {
      title: "NTN咨费",
    }
  },
  {
    path: "/develop",
    name: "Develop",
    component: () => import("@/view/developPage.vue"),
    meta: {
      title: "开发版",
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/view/contactPage.vue"),
    meta: {
      title: "联系我们",
    }
  },
  {
    path: "/info",
    name: "Info",
    component: () => import("@/view/infoPage.vue"),
    meta: {
      title: "信息资料",
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
